export default {
  superDesktop: 'Bericht',
  home: 'Startseite',
  people: 'Menschen',
  directory: 'CRM',
  lists: 'Listen',
  roles: 'Rollen',
  segments: 'Segmente',
  businesses: 'Unternehmen',
  talk: 'sich unterhalten',
  chats: 'Chats',
  conversationMetrics: 'Metriken',
  conversationSettings: 'Chat-Konfiguration',
  communicate: 'Kommunizieren',
  campaigns: 'Kampagnen',
  triggers: 'Trigger',
  notifications: 'Benachrichtigungen',
  connect: 'Verbinden',
  authenticator: 'Authentifikator',
  forms: 'Formen',
  oAuths: 'Oauths',
  crm: 'Crm',
  /* events */
  events: 'Ereignisse',
  myEvents: 'Meine Veranstaltungen',
  categories: 'Kategorien',
  assistants: 'Assistenten',
  promotors: 'Promotoren',
  djs: 'Djs',
  productsCategories: 'Producten Categorieën',
  products: 'Produkte',
  productsSales: 'Produktkäufe',
  /* ORDERS */
  clients: 'Kunden',
  colors: 'Farben',
  containerTypes: 'Containertypen',
  purchases: 'Einkäufe',
  sellers: 'Verkäufer',
  suppliers: 'Lieferanten',
  /* microsites */
  microSites: 'Mikro-Sites',
  configure: 'Konfigurieren',
  generalities: 'Allgemeines',
  apps: 'Apps',
  administrators: 'Administratoren',
  billing: 'Abrechnung',
  graphicAspect: 'Grafischer Aspekt',
  automate: 'automatisieren',
  following: 'Folgen',
  mainTables: 'Haupttabellen',
  panel: 'Panel',
  journeyLeads: 'Reise führt',
  sequences: 'Sequenzen',
  userConfiguration: 'Benutzer Konfiguration'
}
